import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import Container from "@mui/material/Container";
import { styled } from "@mui/styles";
import ButtonBlue from "../../shared/buttonBlue";
import UnicornLoading from "../../assets/loading.gif";
import {
  Grid,
  Typography,
  TextField,
  Tabs,
  Tab,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import QueryBuilderRoundedIcon from "@mui/icons-material/QueryBuilderRounded";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { getCrossAreaCarBookingsByFilterByIdDriver } from "../../../../actions/crossAreaCarBooking";
import {
  getCrossAreaCarPoolBookingByFilterByIdDriver,
  getCrossAreaCarPoolBookingByIdDriver,
} from "../../../../actions/crossAreaCarPoolBooking";
import {
  getInAreaCarBookingByFilterByIdDriver,
  getInAreaCarBookingByIdDriver,
} from "../../../../actions/inAreaCarBooking";
import {
  getDeliveryCarBookingByFilterByDriver,
  getDeliveryCarBookingByIdDriver,
  getDeliveryCarBookingByIdUser,
} from "../../../../actions/deliveryCarBooking";
import {
  getAllDriverBookingByIdUser,
  getDriverBookingByFilterByIdDriver,
  getDriverBookingByIdDriver,
} from "../../../../actions/driverBooking";
import { getDeliverySampleshuttleByIdDriver } from "../../../../actions/deliverySampleshuttle";
import { getBetweenSiteCarByFilter } from "../../../../actions/betweenSiteCarBooking";

import CrossArea from "./crossAreaCar";
import CrossAreaPoolCar from "./crossAreaPoolCar";
import InAreaCar from "./inAreaCar";
import DeliverySampleShuttleCar from "./deliverySampleShuttle";
import DeliveryCar from "./deliveryCar";
import DriverBooking from "./driver";
import BetweenSiteCar from "./betweenSiteCar";

const Root = styled("div")(({ theme }) => ({
  paddingInline: "8vw",
  height: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingInline: "0",
    marginLeft: "0",
    width: "100%",
  },
}));
const DivCoverReturn = styled("div")(({ theme }) => ({
  display: "flex",

  flexDirection: "column",
  marginTop: "20px",
  height: "calc(100% - 64px)",

  "& .ButtonTypeNotClicked": {
    backgroundColor: "#B2BABB ",
    color: "white",
    fontWeight: "bold",
    ["&:hover"]: {
      borderBottom: "0px",
      backgroundColor: "#D5DBDB",
    },
  },
}));
const HeaderOfPage = styled("div")({
  display: "flex",
  flexDirection: "column",
  marginBottom: "20px",
});
const PartOfContent = styled("div")({
  width: "100%",
  height: "calc(100% - 80px)",
});

const Title = styled(Typography)({
  fontSize: "34px",
});

const TabsStyled = styled(Tabs)({
  "& .MuiTab-root": {
    fontSize: "16px",
    fontWeight: "500",
    minWidth: "150px",
    minHeight: "60px",
  },
  "& .MuiTabs-scroller .PrivateTabIndicator-colorSecondary-34": {
    height: "3px",
  },
});

const TabStyled = styled(Tab)({
  fontSize: "14px",
  height: "60px",
});

const MyListsForDriver = (props) => {
  const dispatch = useDispatch();

  const { isFetching: isFetchingBetweenSiteCar, result: betweenSiteCar } =
    useSelector((state) => state.betweenSiteCar);
  const { isFetching: isFetchingCrossAreaBookings, result: crossAreaBookings } =
    useSelector((state) => state.crossAreaCar);
  const {
    isFetching: isFetchingCrossAreaPoolBookings,
    result: crossAreaPoolBookings,
  } = useSelector((state) => state.crossAreaCarPool);
  const { isFetching: isFetchingInAreaBookings, result: inAreaBookings } =
    useSelector((state) => state.inAreaCar);
  const { isFetching: isFetchingDeliveryBookings, result: deliveryBookings } =
    useSelector((state) => state.deliveryCar);
  const { isFetching: isFetchingDeliverySampleShuttleCar, result } =
    useSelector((state) => state.deliverySampleShuttleCar);
  const { isFetching: isFetchingDriverBookings, result: driverBookings } =
    useSelector((state) => state.driverBooking);

  const [typeOfBooking, setTypeOfBooking] = useState("CrossArea");
  const [typeOfBookingPath, setTypeOfBookingPath] = useState(
    "cross_area_car_booking"
  );
  const { user: User } = useSelector((state) => state.auth);
  const [showHistory, setHistory] = useState(0);

  const { register, getValues, control } = useForm();

  const [isStartDate, setStartDate] = useState(null);
  const [isEndDate, setEndDate] = useState(null);

  const [deliverySampleStatus, setDeliverySampleStatus] =
    useState("รอรับสินค้า");
  const deliverySampleShuttleCar = result[deliverySampleStatus];
  const [betweenSiteStatus, setBetweenSiteStatus] =
    useState("รอการจัดหาคนขับรถ");
  const [isSearchActive, setSearchStatus] = useState(false);
  const [filteredResult, setFilteredResult] = useState(
    deliverySampleShuttleCar
  );

  useEffect(() => {
    let path = SplitPathName();
    setTypeOfBookingPath(path);

    if (path === "cross_area_car_booking") {
      setTypeOfBooking("CrossArea");
      dispatch(
        getCrossAreaCarBookingsByFilterByIdDriver({ idDriver: User.idUser })
      );
    } else if (path === "cross_area_car_pool_booking") {
      setTypeOfBooking("CrossAreaPool");
      dispatch(getCrossAreaCarPoolBookingByIdDriver(User.idUser));
    } else if (path === "in_area_car_booking") {
      setTypeOfBooking("InArea");
      dispatch(getInAreaCarBookingByIdDriver(User.idUser));
    } else if (path === "delivery_car_booking") {
      setTypeOfBooking("Delivery");
      dispatch(getDeliveryCarBookingByIdDriver(User.idUser));
    } else if (path === "delivery_sample_shuttle_car_booking") {
      setTypeOfBooking("DeliverySampleShuttleCar");
      dispatch(
        getDeliverySampleshuttleByIdDriver(User.idUser, deliverySampleStatus)
      );
    } else if (path === "between_site_car_booking") {
      setTypeOfBooking("BetweenSiteCar");
      dispatch(
        getBetweenSiteCarByFilter({
          targetStatus: "Waiting",
        })
      );
    } else if (path === "driver_booking") {
      setTypeOfBooking("DriverBooking");
      dispatch(getDriverBookingByIdDriver(User.idUser));
    }
  }, []);

  useEffect(() => {
    if (typeOfBooking === "CrossArea") {
      if (!crossAreaBookings) {
        dispatch(
          getCrossAreaCarBookingsByFilterByIdDriver({ idDriver: User.idUser })
        );
      }
    } else if (typeOfBooking === "CrossAreaPool") {
      if (!crossAreaPoolBookings) {
        dispatch(getCrossAreaCarPoolBookingByIdDriver(User.idUser));
      }
    } else if (typeOfBooking === "InArea") {
      if (!inAreaBookings) {
        dispatch(getInAreaCarBookingByIdDriver(User.idUser));
      }
    } else if (typeOfBooking === "DeliverySampleShuttleCar") {
      if (!deliverySampleShuttleCar) {
        dispatch(
          getDeliverySampleshuttleByIdDriver(User.idUser, deliverySampleStatus)
        );
      }
    } else if (typeOfBooking === "BetweenSiteCar") {
      if (!betweenSiteCar) {
        dispatch(
          getBetweenSiteCarByFilter({
            targetStatus: "Waiting",
          })
        );
      }
    } else if (typeOfBooking === "DriverBooking") {
      if (!driverBookings) {
        dispatch(getAllDriverBookingByIdUser(User.idUser));
      }
    } else {
      if (!deliveryBookings) {
        dispatch(getDeliveryCarBookingByIdUser(User.idUser));
      }
    }
  }, [
    typeOfBooking,
    showHistory,
    deliverySampleStatus,
    deliverySampleShuttleCar,
  ]);

  useEffect(() => {
    if (deliverySampleShuttleCar && isSearchActive) {
      const startDate =
        isStartDate === null
          ? null
          : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10);
      const endDate =
        isEndDate === null
          ? null
          : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10);
      const nameSender = getValues("name");

      const finishedFilteredResult = filterDeliverySamples(
        nameSender,
        startDate,
        endDate,
        deliverySampleShuttleCar
      );
      setFilteredResult(finishedFilteredResult);
    }
  }, [deliverySampleShuttleCar, isSearchActive, deliverySampleStatus]);

  useEffect(() => {
    if (showHistory === 1) {
      if (typeOfBooking === "DeliverySampleShuttleCar") {
        handleStatusFilter("ได้รับสินค้าเรียบร้อย", "DeliverySampleShuttleCar");
      } else if (typeOfBooking === "BetweenSiteCar") {
        handleStatusFilter("Finish", "BetweenSiteCar");
      }
    } else {
      if (typeOfBooking === "DeliverySampleShuttleCar") {
        handleStatusFilter("รอรับสินค้า", "DeliverySampleShuttleCar");
      } else if (typeOfBooking === "BetweenSiteCar") {
        handleStatusFilter("Waiting", "BetweenSiteCar");
      }
    }
  }, [showHistory]);

  const onClickSearch = () => {
    const startDate =
      isStartDate === null
        ? null
        : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10);
    const endDate =
      isEndDate === null
        ? null
        : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10);
    if (typeOfBooking === "CrossArea") {
      dispatch(
        getCrossAreaCarBookingsByFilterByIdDriver({
          name: getValues("name"),
          enddate: endDate,
          startdate: startDate,
          idDriver: User.idUser,
        })
      );
    } else if (typeOfBooking === "CrossAreaPool") {
      dispatch(
        getCrossAreaCarPoolBookingByFilterByIdDriver({
          name: getValues("name"),
          enddate: endDate,
          startdate: startDate,
          idDriver: User.idUser,
        })
      );
    } else if (typeOfBooking === "InArea") {
      dispatch(
        getInAreaCarBookingByFilterByIdDriver({
          name: getValues("name"),
          enddate: endDate,
          startdate: startDate,
          idDriver: User.idUser,
        })
      );
    } else if (typeOfBooking === "BetweenSiteCar") {
      handleStatusFilter(
        betweenSiteStatus === "รอการจัดหาคนขับรถ"
          ? "Waiting"
          : betweenSiteStatus === "รายการเสร็จสิ้น"
          ? "Finish"
          : ["GettingPlace", "ToPlace"],
        "BetweenSiteCar"
      );
    } else if (typeOfBooking === "DriverBooking") {
      dispatch(
        getDriverBookingByFilterByIdDriver({
          name: getValues("name"),
          enddate: endDate,
          startdate: startDate,
          idDriver: User.idUser,
        })
      );
    } else if (typeOfBooking === "DeliverySampleShuttleCar") {
      const nameSender = getValues("name");
      if (showHistory === 0) {
        if (startDate === null && endDate === null && nameSender === "") {
          setDeliverySampleStatus("รอรับสินค้า");
          setSearchStatus(false);
        } else {
          const finishedFilteredResult = filterDeliverySamples(
            nameSender,
            startDate,
            endDate,
            deliverySampleShuttleCar
          );
          setSearchStatus(true);
          setFilteredResult(finishedFilteredResult);
        }
      } else {
        if (startDate === null && endDate === null && nameSender === "") {
          setDeliverySampleStatus("ได้รับสินค้าเรียบร้อย");
          setSearchStatus(false);
        } else {
          const finishedFilteredResult = filterDeliverySamples(
            nameSender,
            startDate,
            endDate,
            deliverySampleShuttleCar
          );
          setSearchStatus(true);
          setFilteredResult(finishedFilteredResult);
        }
      }
    } else if (typeOfBooking === "Delivery") {
      dispatch(
        getDeliveryCarBookingByFilterByDriver({
          name: getValues("name"),
          enddate: endDate,
          startdate: startDate,
          idDriver: User.idUser,
        })
      );
    }
  };
  const SplitPathName = () => {
    return props.location.pathname.split("/")[2];
  };

  const onClickButtonType = (event, path) => {
    setTypeOfBookingPath(path);
    props.history.push(`/myListForDriver/${path}`);
    let type;
    if (path === "cross_area_car_booking") {
      type = "CrossArea";
    } else if (path === "cross_area_car_pool_booking") {
      type = "CrossAreaPool";
    } else if (path === "in_area_car_booking") {
      type = "InArea";
    } else if (path === "delivery_car_booking") {
      type = "Delivery";
    } else if (path === "delivery_sample_shuttle_car_booking") {
      type = "DeliverySampleShuttleCar";
    } else if (path === "between_site_car_booking") {
      type = "BetweenSiteCar";
    } else if (path === "driver_booking") {
      type = "DriverBooking";
    }
    setTypeOfBooking(type);
  };

  const onClickCardHandler = (type, booking, idImageBooking) => {
    props.history.push("/myListForDriver/booking_detail", {
      typeBooking: type,
      idBooking: booking,
      idImageBooking: idImageBooking,
      deliverySampleStatus: deliverySampleStatus,
    });
  };

  const onClickHistory = () => {
    setHistory(1);
  };
  const onClickHistoryClose = () => {
    setHistory(0);
  };

  const handleStatusFilter = (status, typeOfBooking) => {
    if (typeOfBooking === "DeliverySampleShuttleCar") {
      dispatch(
        getDeliverySampleshuttleByIdDriver(User.idUser, deliverySampleStatus)
      );
      setDeliverySampleStatus(status);
    } else if (typeOfBooking === "BetweenSiteCar") {
      if (status == "Waiting") {
        dispatch(
          getBetweenSiteCarByFilter({
            name: getValues("name"),
            startdate:
              isStartDate === null
                ? ""
                : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10),
            enddate:
              isEndDate === null
                ? null
                : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10),
            targetStatus: status,
          })
        );
        setBetweenSiteStatus("รอการจัดหาคนขับรถ");
      } else if (status == "Finish") {
        dispatch(
          getBetweenSiteCarByFilter({
            name: getValues("name"),
            startdate:
              isStartDate === null
                ? ""
                : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10),
            enddate:
              isEndDate === null
                ? null
                : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10),
            idDriver: User.idUser,
            isFinish: true,
          })
        );
        setBetweenSiteStatus("รายการเสร็จสิ้น");
      } else {
        dispatch(
          getBetweenSiteCarByFilter({
            name: getValues("name"),
            startdate:
              isStartDate === null
                ? ""
                : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10),
            enddate:
              isEndDate === null
                ? null
                : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10),
            idDriver: User.idUser,
            targetStatus: status,
          })
        );
        setBetweenSiteStatus("กำลังดำเนินการ");
      }
    }
  };

  const filterDeliverySamples = (nameSender, startDate, endDate, data) => {
    let finalResult = data;
    if (nameSender) {
      finalResult = finalResult.filter((item) => {
        const itemName = item.nameSender ? item.nameSender.toLowerCase() : "";
        return itemName.includes(nameSender.toLowerCase());
      });
    }
    if (startDate !== null || endDate !== null) {
      finalResult = finalResult.filter((item) => {
        const itemDate = item.date.slice(0, 10);
        if (startDate !== null && endDate !== null) {
          return startDate <= itemDate && endDate >= itemDate;
        } else if (startDate !== null) {
          return startDate <= itemDate;
        } else if (endDate !== null) {
          return endDate >= itemDate;
        }
        return true;
      });
    }
    return finalResult;
  };

  return (
    <Container maxWidth="xl">
      <Root>
        <DivCoverReturn className="page">
          <HeaderOfPage>
            <Grid
              container
              sx={(theme) => ({
                marginTop: "30px",
                marginBottom: "30px",
              })}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={8}
                sx={(theme) => ({
                  textAlign: "right",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  [theme.breakpoints.down("md")]: {
                    justifyContent: "center",
                    marginBottom: "20px",
                    textAlign: "center",
                  },
                })}
              >
                {showHistory === 0 && <Title>สถานะรายการของฉัน</Title>}
                {showHistory === 1 && <Title>ประวัติการทำรายการของฉัน</Title>}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={(theme) => ({
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  [theme.breakpoints.down("md")]: { justifyContent: "center" },
                })}
              >
                {showHistory === 0 && (
                  <ButtonBlue
                    variant="contained"
                    onClick={onClickHistory}
                    startIcon={<QueryBuilderRoundedIcon />}
                  >
                    ประวัติรายการ
                  </ButtonBlue>
                )}
                {showHistory === 1 && (
                  <ButtonBlue
                    variant="contained"
                    onClick={onClickHistoryClose}
                    startIcon={
                      <img
                        src="/assets/Image/Icon/list.png"
                        alt="List Icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                    }
                  >
                    สถานะรายการ
                  </ButtonBlue>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              sx={(theme) => ({
                backgroundColor: "rgb(255, 255, 255)",
                height: "fit-content",
                color: "rgb(33, 43, 54)",
                boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
                overflow: "hidden",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: "20px",
                marginBottom: "20px",
                padding: "25px 30px 25px 30px",
                borderRadius: "15px",
                display: "flex",
                gap: "1rem",
              })}
            >
              <Grid
                container
                sx={(theme) => ({
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  [theme.breakpoints.down("md")]: {
                    gap: "1rem",
                  },
                })}
              >
                <Grid item xs={12} md={5} lg={4}>
                  <TextField
                    id="search"
                    type="search"
                    label="ค้นหาชื่อ"
                    inputProps={{ ...register("name") }}
                    fullWidth
                    InputProps={{
                      style: {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2} lg={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} locale="th">
                    <Controller
                      name="Startdate"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <MobileDatePicker
                          {...field}
                          label="วันเริ่มต้น"
                          // clearable
                          inputFormat="DD MMMM YYYY"
                          value={isStartDate}
                          componentsProps={{
                            actionBar: {
                              actions: ["clear"],
                            },
                          }}
                          onChange={(date) => setStartDate(date)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              InputProps={{
                                style: {
                                  borderRadius: "8px",
                                },
                              }}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={2} lg={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} locale="th">
                    <Controller
                      name="Enddate"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <MobileDatePicker
                          {...field}
                          label="วันสิ้นสุด"
                          // clearable
                          minDate={isStartDate}
                          inputFormat="DD MMMM YYYY"
                          value={isEndDate}
                          componentsProps={{
                            actionBar: {
                              actions: ["clear"],
                            },
                          }}
                          onChange={(date) => setEndDate(date)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              InputProps={{
                                style: {
                                  borderRadius: "8px",
                                },
                              }}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <ButtonBlue
                  variant="contained"
                  onClick={onClickSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    width: useMediaQuery((theme) =>
                      theme.breakpoints.down("sm")
                    )
                      ? "100%"
                      : "auto",
                  }}
                >
                  ค้นหา
                </ButtonBlue>
              </Grid>

              <Grid item xs={12} container justifyContent="center">
                <TabsStyled
                  value={typeOfBookingPath}
                  onChange={onClickButtonType}
                  aria-label="Tab-typeOfBooking"
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                >
                  <TabStyled
                    className="classes.TabLeft"
                    id="Tab-crossArea"
                    value="cross_area_car_booking"
                    label="รถข้ามพื้นที่เฉพาะ"
                  />
                  <TabStyled
                    id="Tab-crossAreaPool"
                    value="cross_area_car_pool_booking"
                    label="รถข้ามพื้นที่Pool"
                  />
                  <TabStyled
                    id="Tab-inArea"
                    value="in_area_car_booking"
                    label="รถในพื้นที่"
                  />
                  <TabStyled
                    id="Tab-deliveryItem"
                    value="delivery_car_booking"
                    label="รถรับส่งของ"
                  />
                  <TabStyled
                    id="Tab-deliverySampleShuttle"
                    value="delivery_sample_shuttle_car_booking"
                    label="รถรับส่งตัวอย่าง"
                  />
                  <TabStyled
                    id="Tab-betweenSite"
                    value="between_site_car_booking"
                    label="รถรับส่งระหว่าง Site"
                  />
                  <TabStyled
                    id="Tab-driverBooking"
                    value="driver_booking"
                    label="จองคนขับ"
                  />
                </TabsStyled>
              </Grid>
              <PartOfContent>
                {typeOfBooking === "CrossArea" && (
                  <>
                    {!isFetchingCrossAreaBookings ? (
                      <>
                        {crossAreaBookings && crossAreaBookings.length > 0 ? (
                          <CrossArea
                            booking={crossAreaBookings}
                            typeOfBooking={typeOfBooking}
                            onClickCardHandler={onClickCardHandler}
                            showHistory={showHistory}
                          />
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
                {typeOfBooking === "CrossAreaPool" && (
                  <>
                    {!isFetchingCrossAreaPoolBookings ? (
                      <>
                        {crossAreaPoolBookings &&
                        crossAreaPoolBookings.length > 0 ? (
                          <CrossAreaPoolCar
                            booking={crossAreaPoolBookings}
                            typeOfBooking={typeOfBooking}
                            onClickCardHandler={onClickCardHandler}
                            showHistory={showHistory}
                          />
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}

                {typeOfBooking === "InArea" && (
                  <>
                    {!isFetchingInAreaBookings ? (
                      <>
                        {inAreaBookings && inAreaBookings.length > 0 ? (
                          <InAreaCar
                            booking={inAreaBookings}
                            typeOfBooking={typeOfBooking}
                            onClickCardHandler={onClickCardHandler}
                            showHistory={showHistory}
                          />
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
                {typeOfBooking === "Delivery" && (
                  <>
                    {!isFetchingDeliveryBookings ? (
                      <>
                        {deliveryBookings && deliveryBookings.length > 0 ? (
                          <DeliveryCar
                            booking={deliveryBookings}
                            typeOfBooking={typeOfBooking}
                            onClickCardHandler={onClickCardHandler}
                            showHistory={showHistory}
                          />
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
                {typeOfBooking === "DeliverySampleShuttleCar" && (
                  <>
                    {!isFetchingDeliverySampleShuttleCar ? (
                      <>
                        {showHistory === 0 && (
                          <div
                            style={{
                              display: "flex",
                              paddingBlock: "24px",
                              gap: 10,
                            }}
                          >
                            <ButtonBlue
                              variant={
                                deliverySampleStatus === "รอรับสินค้า"
                                  ? "contained"
                                  : "outlined"
                              }
                              customColor="#F44336"
                              sx={
                                deliverySampleStatus === "รอรับสินค้า"
                                  ? {
                                      "&:hover": {
                                        borderColor: "#d9392e",
                                        backgroundColor: "#d9392e",
                                      },
                                    }
                                  : {
                                      "&:hover": {
                                        backgroundColor: "#ff091105",
                                        borderColor: "#d9392e",
                                      },
                                    }
                              }
                              onClick={() =>
                                handleStatusFilter(
                                  "รอรับสินค้า",
                                  "DeliverySampleShuttleCar"
                                )
                              }
                            >
                              รอรับสินค้า
                            </ButtonBlue>
                            <ButtonBlue
                              variant={
                                deliverySampleStatus === "รับสินค้าเรียบร้อย"
                                  ? "contained"
                                  : "outlined"
                              }
                              customColor="#FF9800"
                              sx={
                                deliverySampleStatus === "รับสินค้าเรียบร้อย"
                                  ? {
                                      "&:hover": {
                                        borderColor: "#de8500",
                                        backgroundColor: "#de8500",
                                      },
                                    }
                                  : {
                                      "&:hover": {
                                        backgroundColor: "#ffb60005",
                                        borderColor: "#de8500",
                                      },
                                    }
                              }
                              onClick={() =>
                                handleStatusFilter(
                                  "รับสินค้าเรียบร้อย",
                                  "DeliverySampleShuttleCar"
                                )
                              }
                            >
                              รับสินค้าเรียบร้อย
                            </ButtonBlue>
                            <ButtonBlue
                              variant={
                                deliverySampleStatus === "ส่งสินค้าเรียบร้อย"
                                  ? "contained"
                                  : "outlined"
                              }
                              customColor="#2196F3"
                              sx={
                                deliverySampleStatus === "ส่งสินค้าเรียบร้อย"
                                  ? {
                                      "&:hover": {
                                        borderColor: "#1878c7",
                                        backgroundColor: "#1878c7",
                                      },
                                    }
                                  : {
                                      "&:hover": {
                                        backgroundColor: "#0088ff08",
                                        borderColor: "#1878c7",
                                      },
                                    }
                              }
                              onClick={() =>
                                handleStatusFilter(
                                  "ส่งสินค้าเรียบร้อย",
                                  "DeliverySampleShuttleCar"
                                )
                              }
                            >
                              ส่งสินค้าเรียบร้อย
                            </ButtonBlue>
                          </div>
                        )}
                        {deliverySampleShuttleCar &&
                        deliverySampleShuttleCar.length > 0 ? (
                          isSearchActive ? (
                            <DeliverySampleShuttleCar
                              booking={filteredResult}
                              typeOfBooking={typeOfBooking}
                              onClickCardHandler={onClickCardHandler}
                              showHistory={showHistory}
                              deliverySampleStatus={deliverySampleStatus}
                              searchStatus={isSearchActive}
                            />
                          ) : (
                            <DeliverySampleShuttleCar
                              booking={deliverySampleShuttleCar}
                              typeOfBooking={typeOfBooking}
                              onClickCardHandler={onClickCardHandler}
                              showHistory={showHistory}
                              deliverySampleStatus={deliverySampleStatus}
                              searchStatus={isSearchActive}
                            />
                          )
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
                {typeOfBooking === "BetweenSiteCar" && (
                  <>
                    {!isFetchingBetweenSiteCar ? (
                      <BetweenSiteCar
                        betweenSiteStatus={betweenSiteStatus}
                        handleStatusFilter={handleStatusFilter}
                        booking={betweenSiteCar}
                        typeOfBooking={typeOfBooking}
                        onClickCardHandler={onClickCardHandler}
                        showHistory={showHistory}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
                {typeOfBooking === "DriverBooking" && (
                  <>
                    {!isFetchingDriverBookings ? (
                      <>
                        {driverBookings && driverBookings.length > 0 ? (
                          <DriverBooking
                            booking={driverBookings}
                            typeOfBooking={typeOfBooking}
                            onClickCardHandler={onClickCardHandler}
                            showHistory={showHistory}
                          />
                        ) : (
                          <Typography
                            style={{ textAlign: "center", fontSize: "24px" }}
                          >
                            ไม่มีรายการ
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={UnicornLoading}
                          alt="Loading..."
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </>
                )}
              </PartOfContent>
            </Grid>
          </HeaderOfPage>
        </DivCoverReturn>
      </Root>
    </Container>
  );
};

export default MyListsForDriver;
